export default "__VITE_ASSET__DPsWRjlt__"